/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationId_accommodation_id } from '../models/AccommodationId_accommodation_id';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationIdService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Returns list of accommodation IDs based on BoundingBox or geo identifiers
     * Retrieves the collection of AccommodationId resources.
     * @param region
     * @param city
     * @param voivodeship
     * @param minLat
     * @param maxLat
     * @param minLon
     * @param maxLon
     * @param page The collection page number
     * @param nocCountry Country ID from Noc
     * @returns AccommodationId_accommodation_id AccommodationId collection
     * @throws ApiError
     */
    public accommodationIdListObtaining(
        region?: string,
        city?: string,
        voivodeship?: string,
        minLat?: number,
        maxLat?: number,
        minLon?: number,
        maxLon?: number,
        page: number = 1,
        nocCountry?: number,
    ): CancelablePromise<Array<AccommodationId_accommodation_id>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/tiling/obtain-ids',
            query: {
                region: region,
                city: city,
                voivodeship: voivodeship,
                'min-lat': minLat,
                'max-lat': maxLat,
                'min-lon': minLon,
                'max-lon': maxLon,
                page: page,
                'noc-country': nocCountry,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
